/* AirFlow — carrousel produit a defilement horizontal (style aparanjan), glissement par transform */
(function(){
  if(window.__afCarousel)return;window.__afCarousel=1;
  document.addEventListener('DOMContentLoaded',function(){
    var afp=document.querySelector('.afp');if(!afp)return;
    var main=afp.querySelector('.afp-main');
    var thumbs=[].slice.call(afp.querySelectorAll('.afp-thumb'));
    if(!main||thumbs.length<1)return;

    var origImg=document.getElementById('afp-main-img');
    var origVid=document.getElementById('afp-main-video');

    // 1) Donnees des slides depuis les vignettes
    var slides=thumbs.map(function(t){return {type:t.getAttribute('data-type'),url:(t.getAttribute('data-full')||'').split('?')[0],raw:t.getAttribute('data-full')};});

    // 2) CSS du carrousel (glissement par transform, fiable partout)
    var st=document.createElement('style');
    st.textContent='.afp-main{overflow:hidden;}.afp-track{display:flex;width:100%;transition:transform .45s cubic-bezier(.4,0,.2,1);will-change:transform;}.afp-slide{flex:0 0 100%;min-width:100%;}.afp-slide>img,.afp-slide>div{width:100%;display:block;}.afp-slide video{width:100%;display:block;}';
    document.head.appendChild(st);

    // 3) Construire la bande de slides
    var track=document.createElement('div');track.className='afp-track';
    slides.forEach(function(s,i){
      var slide=document.createElement('div');slide.className='afp-slide';
      if(s.type==='video'&&origVid){origVid.style.display='block';slide.appendChild(origVid);}
      else{var im=document.createElement('img');im.src=s.raw||(origImg&&origImg.src);im.alt='';im.loading=(i<2?'eager':'lazy');slide.appendChild(im);}
      track.appendChild(slide);
    });

    // 4) Stopper l'auto-rotation de airflow-shop.js (clic synthetique sur la pastille active,
    //    sa fonction met manual=true + stopA, AVANT de retirer ses ecouteurs)
    var swatches=[].slice.call(afp.querySelectorAll('.afp-swatch'));
    var activeSw=afp.querySelector('.afp-swatch.active')||swatches[0];
    if(activeSw){try{activeSw.click();}catch(e){}}

    // 5) Remplacer l'image unique par le carrousel
    if(origImg)origImg.style.display='none';
    main.appendChild(track);

    function slideIndexForUrl(url){if(!url)return -1;var b=url.split('?')[0];for(var k=0;k<slides.length;k++){if(slides[k].url&&slides[k].url===b)return k;}return -1;}
    function setActiveThumb(i){curThumbs.forEach(function(t,j){t.classList.toggle('active',j===i);});}
    function setActiveSwatch(sw){curSwatches.forEach(function(x){x.classList.toggle('active',x===sw);});}

    var cur=0;
    function selectIndex(i){
      if(i<0||i>=slides.length)return;
      cur=i;
      track.style.transform='translateX(-'+(i*100)+'%)';
      setActiveThumb(i);
      var match=null;
      for(var k=0;k<curSwatches.length;k++){if((curSwatches[k].getAttribute('data-img')||'').split('?')[0]===slides[i].url){match=curSwatches[k];break;}}
      if(match){
        setActiveSwatch(match);
        var vid=document.getElementById('afp-vid');if(vid)vid.value=match.getAttribute('data-vid');
        var cn=document.getElementById('afp-cname');if(cn)cn.textContent=match.getAttribute('data-name');
        var dp=match.getAttribute('data-price'),p1=document.getElementById('afp-price'),p2=document.getElementById('afp-addprice');
        if(p1&&dp)p1.textContent=dp;if(p2&&dp)p2.textContent=dp;
      }
    }

    // 6) Recloner vignettes + pastilles pour retirer les anciens ecouteurs, puis brancher les notres
    var curThumbs=[],curSwatches=[];
    thumbs.forEach(function(t,i){var c=t.cloneNode(true);t.parentNode.replaceChild(c,t);curThumbs.push(c);c.addEventListener('click',function(){selectIndex(i);});});
    swatches.forEach(function(s){var c=s.cloneNode(true);c.setAttribute('style',s.getAttribute('style')||'');s.parentNode.replaceChild(c,s);curSwatches.push(c);
      c.addEventListener('click',function(){var idx=slideIndexForUrl(c.getAttribute('data-img'));if(idx<0)idx=0;selectIndex(idx);});
    });

    // 7) Support glissement tactile (swipe) sur mobile
    var x0=null;
    track.addEventListener('touchstart',function(e){x0=e.touches[0].clientX;},{passive:true});
    track.addEventListener('touchend',function(e){if(x0===null)return;var dx=e.changedTouches[0].clientX-x0;if(Math.abs(dx)>40){selectIndex(dx<0?Math.min(cur+1,slides.length-1):Math.max(cur-1,0));}x0=null;},{passive:true});

    // etat initial
    selectIndex(0);
  });
})();
